import { createFeature, createReducer, on } from '@ngrx/store';
import { AuthActions } from '../../actions/auth/auth.actions';
import { UserActions } from '@store/actions/user/user.actions';
import { IdleActions } from '@store/actions/idle/idle.actions';

export const authFeatureKey = 'auth';

export interface State {

  authToken: string,
}

export const initialState: State = {
  authToken: ""
};

export const reducer = createReducer(
  initialState,
  on(AuthActions.getAzureTokenSuccess, (state, action) => ({
    ...state,
    authToken: action.token
  })),
  on(AuthActions.getAzureTokenFailure, (state, action) => ({
    ...state,
    authToken: ""
  })),
  on(UserActions.clearActiveUser, (state, action) => (initialState)),
  on(UserActions.logoutButtonPressed, (state, action) => (initialState)),
  on(IdleActions.timedOut, (state, action) => (initialState)),



);

export const authFeature = createFeature({
  name: authFeatureKey,
  reducer,
});

